import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { FreeReducedMealApp } from '../../../shared-modules/free-reduced-meal-app/models/free-reduced-meal-app.model';

@Component({
  selector: 'app-frma-unsubmitted-app-dialog',
  templateUrl: './frma-unsubmitted-app-dialog.component.html',
  styleUrls: ['./frma-unsubmitted-app-dialog.component.css']
})
export class FrmaUnsubmittedAppDialogComponent implements OnInit {

  application: FreeReducedMealApp;
  textBlock1: string;
  constructor(
    private dialogRef: MatDialogRef<FrmaUnsubmittedAppDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FreeReducedMealApp,
    private translateService: TranslateService
  ) {
    this.application = data;
   }

  ngOnInit(): void {
    if (this.application) {
      this.translateService.get('The most recent application was not submitted.  It was started on {{1}} by {{2}}.').pipe(take(1)).subscribe((res: string) => {
        if (res) {
          this.textBlock1 = res.replace('{{1}}', formatDate(this.application.CreatedDate, 'MM/dd/yy', 'en-US')).replace('{{2}}', this.application.CreatedByName);
        }
      });
    }
  }

  cancelClick() {
    this.dialogRef.close();
  }

  continueClick() {
    this.dialogRef.close('continue');
  }

  newClick() {
    this.dialogRef.close('new');
  }
}
